export const CONTACT = {
  phones: ["+91 99532 95555", "+91 99532 95557", "+91 96257 37778", "+91 70551 57778", "+91 70553 37778", "+91 70553 77778"],
  landline: "0120-4574749",
  primaryPhone: "+919953295555",
  whatsapp: "919953295555",
  emails: ["anuj@cluetrip.co.in", "anuj@cluetripholidays.com", "info@cluetripholidays.com", "cluetripholidays@gmail.com"],
  address: "H-4, H-Block, near Kanak Farm, Block I, Govindpuram, Ghaziabad, Uttar Pradesh 201013",
  mapQuery: "Govindpuram, Ghaziabad, Uttar Pradesh 201013",
  socials: {
    instagram: "https://instagram.com/cluetripholidays",
    facebook: "https://www.facebook.com/CallCluetripHolidays",
    linkedin: "https://www.linkedin.com/in/anuj-sharma-3206b2b3/",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Packages", to: "/packages" },
  { label: "Destinations", to: "/destinations" },
  { label: "Gallery", to: "/gallery" },
  { label: "Services", to: "/", scrollTo: "services" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const PIH = "https://pleasureindiaholidays.com/assets/img";

export const DEST_CARDS = [
  { prefix: "Hills of", name: "Himachal", match: "Himachal", image: `${PIH}/destination/5.webp` },
  { prefix: "Divine", name: "Uttarakhand", match: "Uttarakhand", image: `${PIH}/destination/6.webp` },
  { prefix: "Romantic", name: "Goa", match: "Goa", image: `${PIH}/destination/7.webp` },
  { prefix: "Rangilo", name: "Rajasthan", match: "Rajasthan", image: `${PIH}/destination/8.webp` },
  { prefix: "Exotic", name: "Kerala", match: "Kerala", image: `${PIH}/destination/1.webp` },
  { prefix: "Jannat E", name: "Kashmir", match: "Kashmir", image: `${PIH}/destination/2.webp` },
  { prefix: "North", name: "East", match: "North East", image: `${PIH}/destination/3.webp` },
  { prefix: "Andaman", name: "Island", match: "Andaman", image: `${PIH}/destination/4.webp` },
];

export const INTL_CARDS = [
  { name: "Dubai", match: "Dubai", image: `${PIH}/international-dest/dubai.jpg` },
  { name: "Thailand", match: "Thailand", image: `${PIH}/international-dest/thailand.jpg` },
  { name: "Bali", match: "Bali", image: `${PIH}/international-dest/bali.jpg` },
  { name: "Nepal", match: "Nepal", image: `${PIH}/international-dest/nepal.jpg` },
  { name: "Vietnam", match: "Vietnam", image: "https://images.unsplash.com/photo-1528127269322-539801943592?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const PROMOS = [
  { title: "Himachal Special", offer: "Starting ₹4,499", q: "Himachal", grad: "from-sky-600 to-blue-900" },
  { title: "Kerala Backwaters", offer: "Starting ₹10,999", q: "Kerala", grad: "from-emerald-600 to-teal-900" },
  { title: "Royal Rajasthan", offer: "Starting ₹8,499", q: "Rajasthan", grad: "from-orange-500 to-rose-700" },
  { title: "Char Dham Yatra", offer: "9N/10D · ₹39,499", q: "Char Dham", grad: "from-amber-500 to-orange-800" },
];

export const HERO_SLIDES = [
  {
    pre: "Explore", big: "Manali", post: "with us",
    sub: "Snow peaks, adventure & cosy hill stays — starting ₹4,499",
    q: "Himachal",
    image: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  },
  {
    pre: "Discover", big: "Kerala", post: "backwaters",
    sub: "Houseboats, tea hills & God's own country — starting ₹10,999",
    q: "Kerala",
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  },
  {
    pre: "Dazzling", big: "Dubai", post: "awaits you",
    sub: "Burj Khalifa, desert safari & luxury — starting ₹35,500",
    q: "Dubai",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  },
];

export const SERVICES = [
  { title: "Tour Packages", desc: "Handcrafted domestic & international itineraries tailored to how you love to travel.", icon: "MapTrifold" },
  { title: "Hotel Booking", desc: "From boutique homestays to overwater villas — handpicked, verified stays at the best rates.", icon: "Buildings" },
  { title: "Car / Bus Rental", desc: "Comfortable, well-maintained cars and coaches with trusted drivers for every group size.", icon: "Car" },
  { title: "Destination Wedding", desc: "Dreamy venues, seamless logistics and unforgettable celebrations in magical locations.", icon: "Confetti" },
  { title: "Flight Tickets", desc: "Best-fare flights across every major airline, ticketed and confirmed in minutes.", icon: "AirplaneTilt" },
  { title: "Train Tickets", desc: "Hassle-free rail bookings and reservations across India, sorted end to end.", icon: "Train" },
];

export const DOMESTIC_STATES = [
  "Himachal Pradesh", "Uttarakhand", "Uttar Pradesh", "Jammu & Kashmir", "Rajasthan",
  "Goa", "Gujarat", "Kerala", "Tamil Nadu", "Karnataka", "Sikkim", "Assam", "Meghalaya",
];

export const INTERNATIONAL = [
  "Azerbaijan", "Turkey", "Vietnam", "Singapore", "Nepal", "Thailand",
  "Bhutan", "Malaysia", "Maldives", "Mauritius", "Sri Lanka", "Europe",
];

export const WHY_US = [
  { no: "01", title: "Travel to live, Live to Travel", desc: "We don't sell trips — we craft the memories you'll retell for a lifetime. Every journey is designed around the experiences that move you." },
  { no: "02", title: "Handpicked, never generic", desc: "No copy-paste itineraries. Our experts curate each stay, route and moment so your trip feels made-to-measure." },
  { no: "03", title: "On-ground support, always", desc: "Real people, real numbers. From visa to landing to check-out, our team is a call away, 24/7." },
  { no: "04", title: "Honest, transparent pricing", desc: "What you see is what you pay. No hidden fees, no last-minute surprises — just great value." },
];

export const STATS = [
  { value: "12K+", label: "Happy travellers" },
  { value: "25+", label: "Destinations" },
  { value: "9+", label: "Years of journeys" },
  { value: "4.9", label: "Average rating" },
];

export const TESTIMONIALS = [
  { name: "Ritika & Arjun Sharma", trip: "Maldives Honeymoon", text: "Our honeymoon was flawless — the overwater villa, the transfers, everything was handled. We just had to show up and fall in love with the place all over again.", rating: 5 },
  { name: "Sandeep Verma", trip: "Kerala Family Tour", text: "Travelled with my parents and kids. Cluetrip planned a stress-free trip with the perfect pace. The houseboat night was the highlight of our year.", rating: 5 },
  { name: "Neha Gupta", trip: "Bali Group Trip", text: "Booked for 8 friends and it was seamless. Great hotels, on-time cabs and a coordinator who was a WhatsApp message away the whole time.", rating: 5 },
  { name: "Mohit Aggarwal", trip: "Dubai Getaway", text: "Transparent pricing and zero surprises. The desert safari and Burj Khalifa were perfectly timed. Will definitely book my next trip with them.", rating: 5 },
];
